import type { BrowserRouterProps, HashRouterProps } from 'react-router-dom'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import cfg from '../config'
import { routeMapping } from './index'

export const RouterMode = (props?: BrowserRouterProps | HashRouterProps) => {
  if (routeMapping.length === 1) {
    const OneRoute = routeMapping[0].component
    return OneRoute
  }
  if (cfg.mode === 'browser') {
    return <BrowserRouter basename={`/r/${cfg.name}`}>{props?.children}</BrowserRouter>
  }
  return <HashRouter basename="/">{props?.children}</HashRouter>
}
